/**
 * №13.3 §1 — the inline teaching-error surface for create/edit + launched-verb
 * forms. Renders the verb's teaching error verbatim (message + one-line
 * suggestion + the per-field detail) instead of the bare "Validation failed"
 * that hid exactly what the `individual`-enum bug needed. Accepts either a typed
 * MutationError (from the MCP client) or a plain string (client-side guards).
 */
import type { MutationError } from "../../../lib/types";

export function FormError({ error }: { error: MutationError | string | null }) {
  if (!error) return null;
  const message = typeof error === "string" ? error : error.message;
  const suggestion = typeof error === "string" ? undefined : error.suggestion;
  const fieldErrors = typeof error === "string" ? undefined : error.fieldErrors;

  return (
    <div className="guard guard--blocked" style={{ marginTop: 14 }}>
      <div>{message}</div>
      {suggestion && (
        <div className="tiny muted" style={{ marginTop: 4 }}>{suggestion}</div>
      )}
      {/* When more than one field failed, list each so nothing is hidden. A
          single field error is already spelled out in `message`. */}
      {fieldErrors && fieldErrors.length > 1 && (
        <ul style={{ margin: "6px 0 0", paddingLeft: 18 }}>
          {fieldErrors.map((fe) => (
            <li key={fe.field} className="tiny">{fe.field}: {fe.message}</li>
          ))}
        </ul>
      )}
    </div>
  );
}
